module.exports = __webpack_public_path__ + "static/img/1_simon-migaj-Yui5vfKHuzs-unsplash_thumb.13167ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/1_simon-migaj-Yui5vfKHuzs-unsplash_thumb.png
// module id = qo92
// module chunks = 4